var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutIconTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 211,
    viewBox: "0 0 243 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.527,
    y: 131.984,
    width: 106.695,
    height: 106.695,
    rx: 40,
    transform: "rotate(147.703 220.527 131.984)",
    fill: "#025DE8",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.039,
    y: 124.01,
    width: 106.695,
    height: 106.695,
    rx: 40,
    transform: "rotate(147.703 202.039 124.01)",
    fill: "#025DE8",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.553,
    y: 116.037,
    width: 106.695,
    height: 106.695,
    rx: 40,
    transform: "rotate(147.703 183.553 116.037)",
    fill: "#025DE8",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.098,
    y: 113.057,
    width: 106.695,
    height: 106.695,
    rx: 40,
    transform: "rotate(147.703 169.098 113.057)",
    fill: "#025DE8",
    fillOpacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIconTwo);
export default __webpack_public_path__ + "static/media/about_icon_two.e3ca136971edb40be2a9ded62040f977.svg";
export { ForwardRef as ReactComponent };